export default {"src":"/_next/static/media/quate-icon.86c33076.svg","height":50,"width":50};